var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    fill: "#EFEFEF",
    width: 63,
    height: 17,
    viewBox: "0 0 1000 260.2",
    style: {
      enableBackground: "new 0 0 63 17"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M835,257.2c7.1,0,10.2-3.1,10.2-10.1V113.9c0-7-3.1-10.1-10.2-10.1h-45.3c-7.1,0-10.2,3.1-10.2,10.1v133.2 c0,7,3.1,10.1,10.2,10.1H835z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M355.3,257.2c7.1,0,10.2-3.1,10.2-10.1V113.9c0-7-3.1-10.1-10.2-10.1h-45.3c-7.1,0-10.2,3.1-10.2,10.1v133.2 c0,7,3.1,10.1,10.2,10.1H355.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M387.5,157.5V246c0,7.8,3.1,11.2,10.2,11.2H441c7.4,0,10.2-3.4,10.2-11.2v-76.3c0-8.4,3.4-14.7,23.6-14.7 c19.9,0,23.3,6.2,23.3,14.7V246c0,7.8,3.1,11.2,10.2,11.2h44.7c7.1,0,10.2-3.4,10.2-11.2v-88.5c0-38.1-17.4-63.7-88-63.7 s-88,13.9-88,52"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M969.2,196.4h-9c-5.2,0-9.4-4.2-9.4-9.4v-62h19c4.8,0,6.9-3.2,6.9-10.4V79.6c0-7.2-2.1-10.4-6.9-10.4h-19V43.1 c0-7.8-3.1-11.2-10.2-11.2h-44.1c-7.1,0-10.2,3.4-10.2,11.2v26.2H869c-4.8,0-6.9,3.2-6.9,10.4v34.9c0,7.2,2.1,10.4,6.9,10.4h17.2 v80.6c0,27.9,22.6,50.6,50.5,50.8l32.6,0.3c7.1,0,10.2-3.4,10.2-11.2v-37.8C979.5,199.8,976.3,196.4,969.2,196.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M762.7,247.2l-40.8-79.4l40.7-73.5c2.6-6.6,0.3-10.3-6.3-10.3h-43.8c-7.4,0-11.4,2.8-14.2,10.3l-29.3,44.3h-11.4V44 c0-7.8-3.1-11.2-10.2-11.2h-44.1c-7.1,0-10.2,3.4-10.2,11.2v202.3c0,7.8,3.1,11.2,10.2,11.2h44.1c7.1,0,10.2-3.4,10.2-11.2v-48.7 h11.7l29.2,49.6c2.8,7.5,6.8,10.3,14.2,10.3h43.8C762.9,257.5,765.2,253.8,762.7,247.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M184.8,246.9l-40.8-79.4L184.6,94c2.6-6.6,0.3-10.3-6.3-10.3h-43.8c-7.4,0-11.4,2.8-14.2,10.3L91,138.3H79.6V43.7 c0-7.8-3.1-11.2-10.2-11.2H25.2c-7.1,0-10.2,3.4-10.2,11.2V246c0,7.8,3.1,11.2,10.2,11.2h44.1c7.1,0,10.2-3.4,10.2-11.2v-48.7h11.7 l29.2,49.6c2.8,7.5,6.8,10.3,14.2,10.3h43.8C185.1,257.2,187.3,253.5,184.8,246.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M262.4,257.2c7.1,0,10.2-4.6,10.2-14.9V46.1c0-10.3-3.1-14.9-10.2-14.9h-45.3c-7.1,0-10.2,4.6-10.2,14.9v196.2 c0,10.3,3.1,14.9,10.2,14.9H262.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M569.7,51.1c-0.3-14.7-6.4-20.2-26.4-26.5c-19.9-6.2-35.6-6.8-59.1-6.8c-13.4,0-72.5,5.9-106.7,9.6c-1.5,0.2-2.5,1.6-2.1,3 l2.7,11.7l-2.8-1.1c-0.1-3-2-7.6-3.7-11C364.9,15.2,350,4.9,332.7,4.9c-23.4,0-42.5,19-42.5,42.5s19,42.5,42.5,42.5 c15.5,0,29-8.3,36.4-20.8c44.3-1.4,126-5.7,156.1,5.6c28.5,10.7,33.3,15.9,38.5,19.6C569.9,98.7,570,65.7,569.7,51.1z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 812.4,
    cy: 54.8,
    r: 37.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon2);
export default __webpack_public_path__ + "static/media/logo-icon2.407eec33005eb31af56bccbbd0bb6ce7.svg";
export { ForwardRef as ReactComponent };